/*
 * Palo Alto Theme
 *
 * Use this file to add custom Javascript to Palo Alto.  Keeping your custom
 * Javascript in this fill will make it easier to update Palo Alto. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 */

(function () {
  /**
   * Updates .cart__badge count and visibility in the header when the cart changes.
   * Uses .cart__toggle so it works with or without data-cart-drawer-toggle.
   * @param {number} count - Current cart item count (total quantity)
   */
  function updateHeaderCartBadge(count) {
    const num = Number(count) || 0;
    const toggles = document.querySelectorAll(".cart__toggle");
    toggles.forEach(function (toggle) {
      let badge = toggle.querySelector(".cart__badge");
      if (num > 0) {
        if (!badge) {
          badge = document.createElement("span");
          badge.className = "cart__badge";
          const after = toggle.querySelector(".visually-hidden");
          if (after) {
            toggle.insertBefore(badge, after.nextSibling);
          } else {
            toggle.appendChild(badge);
          }
        }
        badge.textContent = num;
        badge.classList.remove("hidden");
      } else {
        if (badge) {
          badge.classList.add("hidden");
          badge.textContent = "";
        }
      }
    });
  }

  const cartEl = customElements.get("cart-element");

  class CustomCart extends cartEl {
    constructor() {
      super();
      this.initializeEvents();
    }

    initializeEvents() {
      document.addEventListener("custom:cart:updated", (t) => {
        this.addLoadingClass();
        const { oldLineItemKey, id, quantity: rawQuantity } = t.detail;
        const quantity = Number(rawQuantity);

        fetch(theme.routes.cart_url + ".js", {
          method: "get",
          headers: { Accept: "application/json" },
        })
          .then((res) => res.json())
          .then((cart) => {
            const existingItem = cart.items.find(
              (item) => String(item.variant_id) === String(id),
            );
            const newQuantity = existingItem
              ? existingItem.quantity + quantity
              : quantity;
            const updateKey = existingItem ? existingItem.key : id;

            return fetch(theme.routes.cart_update_url, {
              method: "post",
              headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
              },
              body: JSON.stringify({
                updates: {
                  [oldLineItemKey]: 0,
                  [updateKey]: newQuantity,
                },
              }),
            });
          })
          .then(() => {
            this.removeLoadingClass();
            this.getCart();
          });
      });
    }
  }

  customElements.define("custom-cart", CustomCart);

  document.addEventListener("click", function (e) {
    var btn = e.target.closest("[data-coupon-copy]");
    if (!btn) return;
    var code = btn.dataset.couponCopy;
    var tooltip = btn.querySelector("tooltip-component");
    navigator.clipboard.writeText(code).then(function () {
      if (tooltip && typeof tooltip.addPinEvent === "function") {
        tooltip.addPinEvent();
        setTimeout(function () {
          if (
            window.theme &&
            typeof window.theme.closeAllTooltips === "function"
          ) {
            window.theme.closeAllTooltips();
          }
        }, 1500);
      }
    });
  });

  /**
   * Syncs .product-badge markup after a variant AJAX update.
   * Uses the fetched section HTML from theme variantChange payload
   * and updates/adds/removes badges per media slide in current product-info.
   * @param {Object} payload - Pub/sub payload from theme.PUB_SUB_EVENTS.variantChange
   */
  function syncProductBadges(payload) {
    const data = payload && payload.data ? payload.data : null;
    if (!data || !data.sectionId || !data.html) return;

    const sourceRoot =
      data.html.querySelector(
        'product-info[data-original-section="' + data.sectionId + '"]',
      ) ||
      data.html.querySelector(
        'product-info[data-section="' + data.sectionId + '"]',
      ) ||
      data.html.querySelector("product-info");

    if (!sourceRoot) return;

    const targetRoot =
      document.querySelector(
        'product-info[data-original-section="' + data.sectionId + '"]',
      ) ||
      document.querySelector(
        'product-info[data-section="' + data.sectionId + '"]',
      );

    if (!targetRoot) return;

    const sourceSlides = sourceRoot.querySelectorAll(
      "[data-product-slide][data-id]",
    );
    sourceSlides.forEach(function (sourceSlide) {
      const mediaId = sourceSlide.getAttribute("data-id");
      if (!mediaId) return;

      const targetSlide = targetRoot.querySelector(
        '[data-product-slide][data-id="' + mediaId + '"]',
      );
      if (!targetSlide) return;

      const sourceBadge = sourceSlide.querySelector(".product-badge");
      const targetBadge = targetSlide.querySelector(".product-badge");

      if (sourceBadge && targetBadge) {
        targetBadge.outerHTML = sourceBadge.outerHTML;
        return;
      }

      if (!sourceBadge && targetBadge) {
        targetBadge.remove();
        return;
      }

      if (sourceBadge && !targetBadge) {
        const targetLink = targetSlide.querySelector(
          ".product-gallery__media-link",
        );
        if (targetLink) {
          targetLink.insertAdjacentHTML("afterbegin", sourceBadge.outerHTML);
        }
      }
    });
  }

  if (typeof subscribe === "function" && theme && theme.PUB_SUB_EVENTS) {
    subscribe(theme.PUB_SUB_EVENTS.variantChange, syncProductBadges);
  }

  if (typeof subscribe === "function" && theme && theme.PUB_SUB_EVENTS) {
    subscribe(
      theme.PUB_SUB_EVENTS.variantChange,
      function ({ data: { sectionId, variant } }) {
        const productInfo = document.querySelector(
          `product-info[data-section="${sectionId}"]`,
        );
        if (!productInfo || !variant) return;
        const span = productInfo.querySelector("[data-article-number-value]");
        if (span) {
          span.textContent = variant.sku || variant.id;
        }
      },
    );
  }

  function forceLeftAlignedProductThumbs(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var thumbContainers = scope.querySelectorAll(
      "[data-product-single-media-thumbs]",
    );

    thumbContainers.forEach(function (thumbContainer) {
      if (thumbContainer.dataset.thumbsAligned === "true") return;

      var flkty =
        window.theme &&
        window.theme.Flickity &&
        window.theme.Flickity.data(thumbContainer);
      if (!flkty) return;

      flkty.options.cellAlign = "left";
      flkty.resize();
      thumbContainer.dataset.thumbsAligned = "true";
    });
  }

  function forceLeftAlignedProductGallery(root) {
    const scope = root && root.querySelectorAll ? root : document;
    const productInfos = scope.querySelectorAll(
      "product-info.product-single__wrapper--carousel",
    );

    productInfos.forEach(function (productInfo) {
      const slider = productInfo.querySelector(
        "[data-product-single-media-slider]",
      );
      if (!slider || slider.dataset.twoUpAligned === "true") return;

      const flkty =
        window.theme &&
        window.theme.Flickity &&
        window.theme.Flickity.data(slider);
      if (!flkty) return;

      flkty.options.cellAlign = "left";
      flkty.resize();
      flkty.reposition();
      slider.dataset.twoUpAligned = "true";
    });
  }

  function syncGalleryBadgeOverlay(slider) {
    if (!slider) return;

    let overlay = slider.querySelector(
      ":scope > .product-gallery__badge-overlay",
    );
    if (!overlay) {
      overlay = document.createElement("div");
      overlay.className = "product-gallery__badge-overlay";
      overlay.setAttribute("aria-hidden", "true");
      slider.appendChild(overlay);
    }

    const selectedSlide =
      slider.querySelector(".product-gallery__media-slide.is-selected") ||
      slider.querySelector(".product-gallery__media-slide");
    const selectedBadge =
      selectedSlide && selectedSlide.querySelector(".product-badge");

    if (!selectedBadge) {
      overlay.innerHTML = "";
      return;
    }

    const nextMarkup = selectedBadge.outerHTML;
    if (overlay.innerHTML !== nextMarkup) {
      overlay.innerHTML = nextMarkup;
    }
  }

  function initGalleryBadgeOverlay(root) {
    const scope = root && root.querySelectorAll ? root : document;
    const sliders = scope.querySelectorAll(
      "[data-product-single-media-slider]",
    );

    sliders.forEach(function (slider) {
      syncGalleryBadgeOverlay(slider);

      if (slider.dataset.badgeOverlayObserverAttached === "true") return;

      let rafId = null;
      const observer = new MutationObserver(function () {
        if (rafId) return;
        rafId = requestAnimationFrame(function () {
          rafId = null;
          syncGalleryBadgeOverlay(slider);
        });
      });

      observer.observe(slider, {
        subtree: true,
        attributes: true,
        attributeFilter: ["class"],
      });

      slider.dataset.badgeOverlayObserverAttached = "true";
    });
  }

  document.addEventListener("DOMContentLoaded", function () {
    forceLeftAlignedProductGallery(document);
    forceLeftAlignedProductThumbs(document);
    initGalleryBadgeOverlay(document);
  });

  document.addEventListener("theme:product-info:loaded", function (event) {
    forceLeftAlignedProductGallery(event.target);
    requestAnimationFrame(function () {
      forceLeftAlignedProductThumbs(event.target);
    });
    initGalleryBadgeOverlay(event.target);
  });
  document.addEventListener("mouseover", function (e) {
    if (!e.target.closest("hover-disclosure")) return;
    if (!document.body.classList.contains("search-opened")) return;
    document
      .querySelectorAll("search-popdown")
      .forEach(function (searchPopdown) {
        if (
          searchPopdown.details &&
          searchPopdown.details.classList.contains("is-open")
        ) {
          searchPopdown.close();
        }
      });
  });

  window.openEyeAble = function openEyeAble(shopDomain) {
    if (typeof eyeAble_extendIconbar === "function") {
      eyeAble_extendIconbar();
      return;
    }

    var configScript = document.createElement("script");
    configScript.src = "https://cdn.eye-able.com/configs/" + shopDomain + ".js";
    configScript.onload = function () {
      var mainScript = document.createElement("script");
      mainScript.src = "https://cdn.eye-able.com/public/js/eyeAble.js";
      mainScript.onload = function () {
        setTimeout(function () {
          var container = document.getElementById("eyeAble_container_ID");
          if (container && container.shadowRoot) {
            var style = document.createElement("style");
            style.textContent =
              ".animeEyeAble:not(.animeEyeAbleExtended) { display: none !important; }";
            container.shadowRoot.appendChild(style);
          }
          if (typeof eyeAble_extendIconbar === "function")
            eyeAble_extendIconbar();
        }, 300);
      };
      document.head.appendChild(mainScript);
    };
    document.head.appendChild(configScript);
  };

  (function mobileActiveFilters() {
    var MOBILE_SELECTOR = ".collection__active-filters-mobile";
    var armed = false;
    var disarmTimer = null;
    var syncFrame = null;
    var pendingScroll = false;

    function isMobile() {
      var small =
        (window.theme && window.theme.sizes && window.theme.sizes.small) || 768;
      return window.innerWidth < small;
    }

    if (window.customElements && customElements.whenDefined) {
      customElements.whenDefined("collection-filters").then(function () {
        var proto = customElements.get("collection-filters").prototype;
        if (proto.__mobileScrollPatched) return;
        var original = proto.getProductsOffsetTop;
        if (typeof original !== "function") return;
        proto.__mobileScrollPatched = true;
        proto.getProductsOffsetTop = function () {
          if (isMobile()) {
            pendingScroll = true;
            return window.pageYOffset;
          }
          return original.apply(this, arguments);
        };
      });
    }

    function arm() {
      armed = true;
      clearTimeout(disarmTimer);
      disarmTimer = setTimeout(function () {
        armed = false;
      }, 3000);
    }

    function closeDrawer(filters) {
      if (!filters.classList.contains("collection__filters--visible")) return;
      filters.classList.remove("collection__filters--visible");
      setTimeout(function () {
        document.dispatchEvent(
          new CustomEvent("theme:scroll:unlock", { bubbles: true, detail: 0 }),
        );
      }, 0);
    }

    function syncChips(filters) {
      var target = document.querySelector(MOBILE_SELECTOR);
      if (!target) return;
      var source = filters.querySelector(".collection__filters__clear");
      var html = source ? source.innerHTML : "";
      if (target.innerHTML !== html) target.innerHTML = html;
      target
        .querySelectorAll(
          "[data-filter-reset-button], [data-filter-tag-reset-button]",
        )
        .forEach(function (a) {
          a.removeAttribute("data-filter-reset-button");
          a.removeAttribute("data-filter-tag-reset-button");
        });
      var hasChips = target.querySelector("a") !== null;
      target.classList.toggle("has-chips", hasChips);

      if (pendingScroll) {
        pendingScroll = false;
        if (isMobile() && hasChips) {
          target.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      }
    }

    function scheduleSync(filters) {
      if (syncFrame) return;
      syncFrame = requestAnimationFrame(function () {
        syncFrame = null;
        syncChips(filters);
      });
    }

    document.addEventListener("click", function (e) {
      var chip = e.target.closest(MOBILE_SELECTOR + " a");
      if (!chip) return;
      var filters = document.querySelector("[data-collection-filters]");
      var clear =
        filters && filters.querySelector(".collection__filters__clear");
      if (!clear) return;

      var tag = chip.getAttribute("data-tag");
      var href = chip.getAttribute("href");
      var real = null;
      var candidates = clear.querySelectorAll("a");
      for (var i = 0; i < candidates.length; i++) {
        var c = candidates[i];
        if (tag) {
          if (c.getAttribute("data-tag") === tag) {
            real = c;
            break;
          }
        } else if (href && c.getAttribute("href") === href) {
          real = c;
          break;
        }
      }
      if (!real) return; // fall back to normal link navigation

      e.preventDefault();
      arm();
      real.click();
    });

    function watch(filters) {
      if (filters.dataset.mobileActiveFilters === "true") return;
      filters.dataset.mobileActiveFilters = "true";

      new MutationObserver(function () {
        if (
          armed &&
          filters.classList.contains("collection__filters--visible")
        ) {
          armed = false;
          clearTimeout(disarmTimer);
          closeDrawer(filters);
        }
        scheduleSync(filters);
      }).observe(filters, {
        attributes: true,
        attributeFilter: ["class"],
        childList: true,
        subtree: true,
      });

      syncChips(filters);
    }

    function init() {
      document.querySelectorAll("[data-collection-filters]").forEach(watch);
    }

    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", init);
    } else {
      init();
    }
  })();
})();

(function () {
  /**
   * Localization selector: a trigger that opens a popout panel anchored directly below it
   * (like the theme's popout-select), with a country dropdown and a language dropdown whose
   * options depend on the selected country, plus a submit button. Selecting updates hidden
   * inputs; the submit button posts Shopify's localization form (country_code +
   * locale_code). Self-contained, so multiple instances can coexist on a page.
   */
  var LIST_VISIBLE = "select-popout__list--visible";
  var PANEL_OPEN = "localization-panel--open";

  if (!customElements.get("localization-selector")) {
    customElements.define(
      "localization-selector",
      class LocalizationSelector extends HTMLElement {
        connectedCallback() {
          this.trigger = this.querySelector("[data-lm-open]");
          this.panel = this.querySelector("[data-lm-panel]");
          this.form = this.querySelector("form");
          this.countryInput = this.querySelector("[data-lm-country-input]");
          this.localeInput = this.querySelector("[data-lm-locale-input]");
          this.countryValue = this.querySelector("[data-lm-country-value]");
          this.languageValue = this.querySelector("[data-lm-language-value]");
          this.languageList = this.querySelector('[data-lm-list="language"]');
          this.languageField = this.querySelector("[data-lm-language-field]");
          // Inline mode (e.g. the first-visit modal) has no trigger/panel: the fields are
          // always visible and only the dropdowns + submit need wiring. Require just the form.
          if (!this.form) return;

          this.addEventListener("click", this.onClick.bind(this));
          this.onDocClick = this.onDocClick.bind(this);
          this.onKeydown = this.onKeydown.bind(this);
          document.addEventListener("click", this.onDocClick);
          document.addEventListener("keydown", this.onKeydown);
        }

        disconnectedCallback() {
          document.removeEventListener("click", this.onDocClick);
          document.removeEventListener("keydown", this.onKeydown);
        }

        onDocClick(evt) {
          if (!this.panel) return;
          if (!this.contains(evt.target)) this.closePanel();
        }

        onKeydown(evt) {
          // In inline mode there is no panel; Escape is handled by the native <dialog>.
          if (!this.panel) return;
          if (evt.key === "Escape" && this.isOpen()) {
            this.closePanel();
            if (this.trigger) this.trigger.focus();
          }
        }

        isOpen() {
          return this.panel && !this.panel.hidden;
        }

        onClick(evt) {
          if (this.trigger && evt.target.closest("[data-lm-open]")) {
            this.togglePanel();
            return;
          }
          const toggle = evt.target.closest("[data-lm-toggle]");
          if (toggle) {
            this.toggleDropdown(toggle);
            return;
          }
          const country = evt.target.closest("[data-lm-country]");
          if (country) {
            this.selectCountry(country);
            return;
          }
          const language = evt.target.closest("[data-lm-language]");
          if (language) {
            this.applyLanguage(language);
            this.markCurrent(language);
            this.closeDropdowns();
            return;
          }
          // Click inside the panel but outside a dropdown list: close open dropdowns.
          if (!evt.target.closest("[data-lm-list]")) this.closeDropdowns();
        }

        togglePanel() {
          if (!this.panel) return;
          if (this.isOpen()) this.closePanel();
          else this.openPanel();
        }

        openPanel() {
          if (!this.panel) return;
          this.panel.hidden = false;
          this.classList.add(PANEL_OPEN);
          if (this.trigger) this.trigger.setAttribute("aria-expanded", "true");
        }

        closePanel() {
          if (!this.panel) return;
          this.closeDropdowns();
          this.panel.hidden = true;
          this.classList.remove(PANEL_OPEN);
          if (this.trigger) this.trigger.setAttribute("aria-expanded", "false");
        }

        toggleDropdown(toggle) {
          const key = toggle.getAttribute("data-lm-toggle");
          const list = this.querySelector('[data-lm-list="' + key + '"]');
          if (!list) return;
          const willOpen = !list.classList.contains(LIST_VISIBLE);
          this.closeDropdowns();
          if (willOpen) {
            list.classList.add(LIST_VISIBLE);
            toggle.setAttribute("aria-expanded", "true");
          }
        }

        closeDropdowns() {
          this.querySelectorAll("[data-lm-list]").forEach((l) => l.classList.remove(LIST_VISIBLE));
          this.querySelectorAll("[data-lm-toggle]").forEach((t) => t.setAttribute("aria-expanded", "false"));
        }

        selectCountry(option) {
          const code = option.getAttribute("data-lm-country");
          this.countryInput.value = code;
          if (this.countryValue) this.countryValue.innerHTML = option.innerHTML;
          this.markCurrent(option);
          // Show only the selected country's languages, reset to its first one.
          let first = null;
          this.languageList.querySelectorAll("[data-lm-lang-country]").forEach((li) => {
            const match = li.getAttribute("data-lm-lang-country") === code;
            li.hidden = !match;
            if (match && !first) first = li.querySelector("[data-lm-language]");
          });
          if (first) {
            this.applyLanguage(first);
            this.markCurrent(first);
          }
          // A market with no languages of its own has nothing to offer: hide the field instead
          // of opening an empty dropdown, and keep the stale locale out of the submitted form.
          this.setLanguageFieldEnabled(Boolean(first));
          this.closeDropdowns();
        }

        setLanguageFieldEnabled(enabled) {
          if (this.languageField) this.languageField.hidden = !enabled;
          if (this.localeInput) this.localeInput.disabled = !enabled;
        }

        applyLanguage(option) {
          this.localeInput.value = option.getAttribute("data-lm-language");
          const label = option.querySelector(".localization-panel__option-label");
          if (this.languageValue) this.languageValue.textContent = label ? label.textContent.trim() : "";
        }

        markCurrent(option) {
          const list = option.closest("[data-lm-list]");
          if (!list) return;
          list
            .querySelectorAll(".select-popout__item--current")
            .forEach((i) => i.classList.remove("select-popout__item--current"));
          const li = option.closest("li");
          if (li) li.classList.add("select-popout__item--current");
        }
      }
    );
  }
})();

(function () {
  /**
   * Localization confirmation modal: opens the centered <dialog> on every page load until the
   * visitor confirms with submit (tracked in localStorage). It cannot be dismissed otherwise —
   * backdrop clicks are ignored and Escape (the dialog's "cancel" event) is prevented. The
   * dialog body reuses the localization selector, so the dropdowns and submit are already wired.
   */
  var STORAGE_KEY = "schiesser:localization-confirmed";

  function confirmed() {
    try {
      return localStorage.getItem(STORAGE_KEY) === "1";
    } catch (e) {
      return false;
    }
  }

  function markConfirmed() {
    try {
      localStorage.setItem(STORAGE_KEY, "1");
    } catch (e) {
      /* private mode / storage disabled: modal simply shows again next visit */
    }
  }

  document.addEventListener("DOMContentLoaded", function () {
    var modal = document.querySelector("[data-localization-modal]");
    if (!modal || typeof modal.showModal !== "function" || confirmed()) return;

    modal.showModal();

    // Non-dismissible: swallow backdrop clicks and prevent Escape from closing the dialog.
    modal.addEventListener("click", function (evt) {
      evt.stopPropagation();
    });
    modal.addEventListener("cancel", function (evt) {
      evt.preventDefault();
    });

    // Only confirming via submit dismisses it. Persist before the form posts and reloads.
    var form = modal.querySelector("form");
    if (form) {
      form.addEventListener("submit", markConfirmed);
    }
  });
})();

(function () {
  /**
   * Geo popup (SCHI-371): offers visitors located in Germany a link to the German shop. Germany
   * is not a Shopify market, so the country comes from Shopify's GeoIP lookup instead of
   * Liquid. The lookup is cached per session, so it costs one request per visit, and skipped
   * entirely once the visitor has closed the popup (tracked in localStorage).
   *
   * Never redirects on its own (EU Geo-blocking Regulation): leaving takes a click on the link.
   */
  var DISMISSED_KEY = "schiesser:geo-popup-dismissed";
  var COUNTRY_KEY = "schiesser:geo-country";

  function read(storage, key) {
    try {
      return window[storage].getItem(key);
    } catch (e) {
      return null;
    }
  }

  function write(storage, key, value) {
    try {
      window[storage].setItem(key, value);
    } catch (e) {
      /* private mode / storage disabled: the popup simply asks again next time */
    }
  }

  function detectCountry() {
    var cached = read("sessionStorage", COUNTRY_KEY);
    if (cached !== null) return Promise.resolve(cached);

    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
    return fetch(root + "browsing_context_suggestions.json?country[enabled]=true")
      .then(function (response) {
        return response.ok ? response.json() : null;
      })
      .then(function (data) {
        var detected = data && data.detected_values && data.detected_values.country;
        var country = (detected && detected.handle) || "";
        write("sessionStorage", COUNTRY_KEY, country);
        return country;
      })
      .catch(function () {
        return "";
      });
  }

  document.addEventListener("DOMContentLoaded", function () {
    var popup = document.querySelector("[data-geo-popup]");
    if (!popup || typeof popup.showModal !== "function") return;
    if ((window.Shopify && window.Shopify.designMode) || read("localStorage", DISMISSED_KEY) === "1") return;

    detectCountry().then(function (country) {
      if (country !== popup.getAttribute("data-geo-popup-country")) return;

      popup.addEventListener("close", function () {
        write("localStorage", DISMISSED_KEY, "1");
        document.dispatchEvent(new CustomEvent("theme:scroll:unlock", { bubbles: true }));
      });

      popup.querySelector("[data-geo-popup-stay]").addEventListener("click", function () {
        popup.close();
      });

      popup.showModal();
      document.dispatchEvent(new CustomEvent("theme:scroll:lock", { bubbles: true, detail: popup }));
    });
  });
})();

(function () {
  /**
   * EU legal guarantee notice: opens the official notice graphic in a native <dialog>.
   * The graphic is a ~400 KB A4 SVG, so the <img> ships without a src and only gets one on the
   * first open — a page where nobody opens the notice never downloads it.
   *
   * Returns false when the dialog cannot be opened, so the trigger stays a working link to the
   * graphic instead of a dead element.
   */
  function openNotice(trigger) {
    var dialog = document.getElementById(trigger.getAttribute("data-legal-guarantee-open"));
    if (!dialog || typeof dialog.showModal !== "function") return false;

    var image = dialog.querySelector("[data-src]");
    if (image) {
      image.src = image.getAttribute("data-src");
      image.removeAttribute("data-src");
    }

    dialog.showModal();
    return true;
  }

  document.addEventListener("DOMContentLoaded", function () {
    var triggers = document.querySelectorAll("[data-legal-guarantee-open]");
    if (!triggers.length) return;

    triggers.forEach(function (trigger) {
      trigger.addEventListener("click", function (evt) {
        if (openNotice(trigger)) evt.preventDefault();
      });
    });

    document.querySelectorAll("[data-legal-guarantee-dialog]").forEach(function (dialog) {
      // The inner card fills the dialog box, so the only clicks that target the dialog element
      // itself come from the backdrop. Escape is handled by the native <dialog>.
      dialog.addEventListener("click", function (evt) {
        if (evt.target === dialog) dialog.close();
      });

      var close = dialog.querySelector("[data-legal-guarantee-close]");
      if (close) {
        close.addEventListener("click", function () {
          dialog.close();
        });
      }
    });
  });
})();
